/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Person/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Person({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content/SourceInvoice/PaymentPlanType/Person"
  
}) {
let constantData = 'Invoice #'
let editAutopayInfoReceivableHumanReadableIdValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'receivable.human_readable_id',
})
let constantData1 = ' - Payor: '
let editAutopayInfoReceivablePaymentAccountPersonPaymentAccountPayerPersonValueData = fromData.useDataFormat({ viewPath,
context: 'edit_autopay_info',
path: 'receivable.payment_account.person_payment_account.payer_person',
format: fromFormat.personName,
})
let aggregateData = fromAggregate.joinNoSpace(constantData, editAutopayInfoReceivableHumanReadableIdValueData, constantData1, editAutopayInfoReceivablePaymentAccountPersonPaymentAccountPayerPersonValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="'Invoice #'"
 data="edit_autopay_info.receivable.human_readable_id"
 aggregate="/Data/aggregate.js joinNoSpace"
 data="' - Payor: '"
 data="edit_autopay_info.receivable.payment_account.person_payment_account.payer_person"
 format="/Data/format.js personName"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}